<template>
  <v-app id="root">
    <v-app-bar
      app
      dark
      dense
      color="white"
      class="app-header"
      style="
        height: 4.375rem;
        z-index: 1;
        margin-bottom: 16px !important;
        padding: 0.5rem 1rem;
        box-shadow: 0 0.15rem 1.75rem 0 rgba(58, 59, 69, 0.15) !important;
      "
    >
      <v-spacer></v-spacer>
      <div style="width: 0; border-right: 1px solid #e3e6f0; height: calc(4.375rem - 2rem); margin: auto 1rem"></div>
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn text v-bind="attrs" v-on="on">
            <span style="color: grey; text-transform: none; margin-right: 5px">{{ userName }}</span>
            <v-icon style="color: grey">{{ "mdi-account" }} </v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="Salir()">
            <v-icon style="font-size: 0.85rem; margin-right: 0.55rem">fas fa-sign-out-alt fa-sm fa-fw mr-2</v-icon>
            <v-list-item-title>{{ "Salir" }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-navigation-drawer absolute permanent width="224px" color="#b600cd" style="z-index: 2">
      <template v-slot:prepend>
        <div style="display: flex; padding: 1.5rem 1rem; height: 70px; align-items: center">
          <div>
            <img
              src="../../../../public/img/favicon_blanco.png"
              style="height: 50px; width: 50px; vertical-align: middle; border-style: none"
            />
          </div>
          <v-list-item-title
            class="mx-3"
            style="color: white; font-size: 1rem; font-weight: 800; text-align: center; text-transform: uppercase; letter-spacing: 0.05rem"
            >Portal Kiin</v-list-item-title
          >
        </div>
      </template>
      <v-divider style="margin: 0 1rem"></v-divider>
      <v-list-item to="dashboard" class="ma-0" style="height: 56px; text-decoration: none">
        <v-list-item-icon style="margin: 0px !important; align-self: center">
          <v-icon style="font-size: 0.85rem; margin-right: 0.55rem" color="white">fas fa-tachometer-alt</v-icon>
        </v-list-item-icon>
        <v-list-item-content style="padding: 0">
          <v-list-item-title style="color: white; font-weight: 700; font-size: 0.85rem">{{ "Dashboard" }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider style="margin: 0 1rem 1rem"></v-divider>
      <v-list dense class="py-0">
        <v-list-item-title style="color: white; padding: 0 1rem; font-weight: 800; font-size: 0.65rem; text-transform: uppercase">{{
          "Autorizaciones"
        }}</v-list-item-title>
        <v-list-item
          class="ma-0"
          style="height: 40px; padding: 8px 16px; text-decoration: none"
          v-for="item in items"
          :to="item.name"
          :key="item.title"
          v-if="checkPermissions(item.per)"
        >
          <v-list-item-icon style="margin: 0px !important; align-self: center; display: flex; justify-content: center">
            <v-icon style="font-size: 0.85rem; margin-right: 0.55rem" color="white">{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content style="padding: 0">
            <v-list-item-title style="color: white; font-weight: 400; font-size: 0.85rem">{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider style="margin: 0 1rem 1rem"></v-divider>
    </v-navigation-drawer>
    <v-main style="padding: 70px 0px 12px 224px; margin-top: 16px; background-color: #f8f9fc">
      <router-view></router-view>
    </v-main>
    <footer class="sticky-footer bg-white">
      <div class="container my-auto">
        <div class="copyright text-center my-auto">
          <span>Copyright &copy; Tecnosis SA de CV 2023</span>
        </div>
      </div>
    </footer>
  </v-app>
</template>

<script>
import Vue from "vue";
import { mapState, mapActions } from "vuex";
import { EventBus } from "@/utils/EventBus";
import { VersionIxeEnum } from "@/utils/enums/VersionIxeEnum";

export default {
  data() {
    return {
      opcion_selected: "General",
      userName: "",
      items: [
        { title: "Ausencias", icon: "fas fa-window-close", path: "ausencias", name: "Ausencias", per: "Soporte" },
        { title: "Intercambios", icon: "fas fa-people-carry", path: "cambios", name: "Cambios", per: "Soporte" },
        { title: "Cambios de horario", icon: "fas fa-people-carry", path: "cambio_de_horario", name: "Cambio_De_Horario", per: "Soporte" },
        { title: "Botón de pánico", icon: "fas fa-bullhorn", path: "boton_panico", name: "Boton_Panico", per: "Soporte" },
        { title: "Excepciones", icon: "fas fa-exclamation", path: "excepciones", name: "Excepciones", per: "Soporte" },
        { title: "Supervisores", icon: "fas fa-folder", path: "supervisores", name: "Supervisores", per: "Supervisores" },
        {
          title: "Excepciones Supervisor",
          icon: "fas fa-exclamation",
          path: "excepcionesSupervisores",
          name: "ExcepcionesSupervisores",
          per: "Supervisores",
        },
      ],
    };
  },
  methods: {
    Li_Alertas(event) {
      $("#Li_Alertas").tooltip("hide");
    },
    Dashboard() {
      this.$router.push({ name: "Dashboard" });
    },
    // Retardos(){
    //   this.$router.push({name:'Retardos'});
    // },
    checkPermissions(item) {
      if (item === "Supervisores" && this.supervisor) {
        return true;
      }
      if (item === "Soporte" && !this.supervisor) {
        return true;
      }
      return false;
    },
    Salir() {
      EventBus.$emit("custom-event:logout");
      this.$msal.signOut();
      this.$router.push({ name: "Login" });
    },
    Ausencias() {
      this.$router.push({ name: "Ausencias" });
    },
    Tiempos_Libres() {
      this.$router.push({ name: "Tiempos_Libres" });
    },
    No_Hacer_Nada(event) {
      event.preventDefault();
    },
    Intercambios() {
      this.$router.push({ name: "Cambios" });
    },
    Cambios_Horario() {
      this.$router.push({ name: "Cambio_De_Horario_Page" });
    },
    Boton_Panico() {
      this.$router.push({ name: "Boton_Panico_Page" });
    },
    ...mapActions(["Actualizar_Usuario", "Actualizar_TokenRefresh", "Actualizar_Token", "Asignar_Interceptor_Token"]),
  },
  computed: {
    menu() {
      return this.$store.getters.getMenu;
    },
    systemClass() {
      if (this.usuario == null) {
        return "sistema-indefinido";
      }

      return {
        "sistema-R3": VersionIxeEnum.R3 == this.usuario.sistema,
        "sistema-R7": VersionIxeEnum.R7 == this.usuario.sistema,
      };
    },
    ...mapState({
      usuario: (state) => state.menu.menu.usuario,
      supervisor: (state) => state.menu.menu.supervisor,
    }),
  },
  beforeRouteEnter(to, from, next) {
    // Los charts fallan porque por algúna razón el contexto es nulo
    setTimeout(() => {
      next();
    }, 300);
  },
  created() {},
  mounted() {
    var that = this;
    this.userName = this.usuario.usuario.nomagente_sistema;
    $(document).ready(function () {
      $('[data-toggle="tooltip"]').each(function (key, element) {
        $(element).tooltip();
      });
    });

    this.$nextTick(function () {
      this.Dashboard();
    });
  },
};
</script>

<style scoped>
#accordionSidebar.sistema-indefinido [class^="schedule-"],
#accordionSidebar.sistema-R3 .schedule-free-time {
  display: none;
}
.v-application ul,
.v-application ol {
  padding-left: 0px;
}
div.v-navigation-drawer__prepend {
  height: 70px !important;
}
a {
  text-decoration: none;
}
</style>
